import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const PaymentCampaignHolder = styled.div`
  .ant-collapse-header {
    color: ${Colors.primaryAccent} !important;
    font-size: 24px !important;
    padding: 20px !important;
    padding-left: 8px !important;
    padding-right: 15px !important;
  }
  .ant-collapse-sub-header {
    color: ${Colors.primaryAccent} !important;
    margin-bottom: 10px;
    font-size: 20px;
    padding-top: 0px;
    padding-right: 15px;
    margin-top: 20px;
  }
  .fieldForm {
    display: flex;
    margin-right: 16px;
    margin-bottom: 0;
    justify-content: space-between;
  }
  .ant-form-item {
    width: 100%;
  }
  .title-form {
    margin-bottom: 0px;
    margin-top: 20px;
  }
  .ant-form {
    padding-left : 10px;
  }
  .content-row {
    margin-top: 20px;
    margin-left: 10px
  }
  .content-card {
    border-radius: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: ${Colors.background};
  }
  .divider-payment {
    display: block;
    min-width: 63% !important;
    height: 2px;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .container {
    display: flex;
    justify-content: space-between;
  }
  .container-button {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    margin-right: 80px;
  }
  .checkoutButton{
    width: 100%;
    min-width: 200px;
    height: 45px;
    font-size: 17px;
    font-weight: 600;
    border-radius: 10px;
  }
  .finishedButtons {
    position: fixed;
    width: 11%;
    z-index: 996;
    top: 145px;
    right: 10px;
    height: 45px;
    line-height: 30px;
    background-color: ${Colors.primary};
    font-size: 18px;
    text-align: center;
    color: ${Colors.onPrimary};
    border-radius: 8px;
    @media only screen and (max-width: 1200px) {
      width: 30%;
      top: 140px;
    }
    @media only screen and (max-width: 500px) {
      width: 40%;
      top: 140px;
    }
  }
  /* Botón secundario: su fondo es la misma superficie que la tarjeta que lo
     contiene, así que sin un borde propio no se lee como botón (en oscuro queda
     directamente invisible). Lleva el borde en el color de marca, igual que su
     texto, para que se distinga del fondo en los dos temas. */
  .proposalButton {
    background-color: ${Colors.snow};
    margin-right: 0px !important;
    color: ${Colors.primaryAccent} !important;
    border-color: ${Colors.primaryAccent};
    z-index: auto;
    position: fixed;
    top: 200px;

    @media only screen and (max-width: 1200px) {
      position: relative;
      margin-left: 10px;
      bottom: 0px;
      top: 0px;
      left: 0px;
    }
  }
`;

export default PaymentCampaignHolder;

